// Scooter domain constants shared between provider dashboards and traveler
// marketplaces. The former static demo catalogue (SCOOTERS / PROVIDERS /
// galleryFor / getScooterById) was retired once V1 reached production parity
// with MongoDB — all listings now come from `/api/services`.

export const ZONES = ['Patong', 'Kata', 'Karon', 'Kamala', 'Rawai', 'Chalong', 'Phuket Town'];

// Single source of truth: Brand list for both provider listing creation and traveler filters
export const BRANDS = ['Honda', 'Yamaha', 'Suzuki', 'Kawasaki', 'Piaggio', 'Vespa', 'SYM', 'Kymco', 'Autre'];

// Single source of truth: Category classification for both provider and traveler
export const CATEGORIES = [
  {
    id: 'urbain',
    label: 'Urbain',
    description: 'Scooters légers et agiles pour la ville.',
    examples: 'Click, Scoopy, Grand Filano, Fazzio, etc.'
  },
  {
    id: 'confort',
    label: 'Confort',
    description: 'Scooters confortables pour ville et route.',
    examples: 'PCX, NMAX, ADV 160, Aerox, etc.'
  },
  {
    id: 'maxi',
    label: 'Maxi-Scooter',
    description: 'Scooters puissants (+300cc) pour longues distances.',
    examples: 'XMAX 300, ADV 350, TMAX, X-ADV, Forza 750, etc.'
  },
  {
    id: 'premium',
    label: 'Premium',
    description: 'Grosses motos premium (trail, GT, touring).',
    examples: 'BMW GS, Africa Twin, Tracer, Ténéré, etc.'
  },
];

// Option label shown in the provider's category menus (creation and edit):
// translated name + model examples, e.g. "Confort — PCX, NMAX, ADV 160, Aerox, etc."
export const categoryOptionLabel = (t, c) =>
  `${t(`listingsMgmt.editScooter.cat.${c.label}`, { defaultValue: c.label })} — ${c.examples}`;
